import { render } from "./AdminPoolincome.vue?vue&type=template&id=d9c4aa8a&scoped=true"
import script from "./AdminPoolincome.vue?vue&type=script&lang=js"
export * from "./AdminPoolincome.vue?vue&type=script&lang=js"

import "./AdminPoolincome.vue?vue&type=style&index=0&id=d9c4aa8a&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c4aa8a"]])

export default __exports__